// Get key JS Script
export const loadKeyJS = (callback?: (status: boolean) => void) => {
  const existingScript = document.getElementById('loadGetKey');
  if (!existingScript) {
    const script = document.createElement('script');
    // XX=Format ID
    // YYYYYYYYYYYY = Subscriber ID (unique value assigned by Merchant Services)
    script.src = `${process.env.REACT_APP_PAYMENT_TECH_URL}/pie/v1/64100000000207/getkey.js`;
    script.id = 'loadGetKey';
    document.body.appendChild(script);
    script.onload = () => {
      if (callback) callback(true);
    };
    script.onerror = () => {
      if (callback) callback(false);
    };
  }
  if (existingScript && callback) callback(true);
};

// Encryption JS Script
export const loadEncryptionJS = (callback?: (status: boolean) => void) => {
  const existingScript = document.getElementById('loadEncryption');
  if (!existingScript) {
    const script = document.createElement('script');
    // Returns Functions to validate Credit card number and encrypt card data
    script.src = `${process.env.REACT_APP_PAYMENT_TECH_URL}/pie/v1/encryption.js`;
    script.id = 'loadEncryption';
    document.body.appendChild(script);
    script.onload = () => {
      if (callback) callback(true);
    };
    script.onerror = () => {
      if (callback) callback(false);
    };
  }
  if (existingScript && callback) callback(true);
};
// Functions From Encryption JS
// This function checks whether getkey.js is loaded.
const isPieKeyDownloadError = () => {
  return typeof window.PIE === 'undefined';
};
// This function checks whether encryption.js is loaded.
const isPieEncryptionDownloadError = () => {
  return (
    typeof window.ValidatePANChecksum !== 'function' ||
    typeof window.ProtectPANandCVV !== 'function'
  );
};

// This function will encrypt credit card number and cvv
export const doEncryption = (cardNumber: string, cvvNumber: string) => {
  const embed = false;
  let isValid = true;
  let errors = '';
  if (isPieEncryptionDownloadError()) {
    isValid = false;
    errors = 'Failed to load encryption.js file';
  } else if (isPieKeyDownloadError()) {
    isValid = false;
    errors = 'Failed to load getkey.js file';
  } else if (!window.ValidatePANChecksum(cardNumber)) {
    // Here Checking MOD 10 digit, since PIE embedded encryption
    // requires that the MOD 10 checksum is valid.
    isValid = false;
    errors = 'Card Number is Invalid';
  }
  const result = window.ProtectPANandCVV(cardNumber, cvvNumber, !embed);
  return {
    isValid,
    result,
    errors,
    phase: window.PIE?.phase?.toString(),
    keyId: window.PIE?.key_id,
  };
};
